"use client";

import { Toaster as Sonner, toast } from "sonner";
import * as React from "react";
import { useTheme } from "../theme";

export type ToasterProps = React.ComponentProps<typeof Sonner>;

export function Toaster(props: ToasterProps) {
  const { resolvedTheme } = useTheme();
  return (
    <Sonner
      theme={resolvedTheme}
      className="toaster"
      toastOptions={{
        classNames: {
          toast:
            "group toast bg-bg-elevated text-fg border border-border shadow-md rounded-md",
          description: "text-fg-muted",
          actionButton: "bg-accent text-accent-fg",
          cancelButton: "bg-muted text-fg",
        },
      }}
      {...props}
    />
  );
}

export { toast };
